/**
 * Actycrea: header.esm.js (ES6)
 * MIT
 */
import { PREFIX } from '../helpers/config.js';

const SELECTOR      = `data-${PREFIX}-myhd`;
const SELECTOR_DATA = `[${SELECTOR}]`;

const DEFAULTS = {
  offsetTop  : 60 ,     // px: hasta aquí se considera "en top"
  hideDelta  : 250 ,    // px seguidos desplazando hacia abajo para ocultar
  showDelta  : 250 ,    // px seguidos desplazando hacia arriba para mostrar
  classHidden: 'headerHidden',
  classOnTop : 'headerOnTop'
};

export class MyHD {
  /**
   * @param {HTMLElement} element
   * @param {Object}      config
   */
  constructor( element , config = { } ){
    if( !(element instanceof HTMLElement) ) throw new Error('MyHD: element inválido');

    this._config  = { ...DEFAULTS , ...config };
    this._element = element;

    // estado
    this._lastY   = Math.max( 0 , window.scrollY || window.pageYOffset || 0 );
    this._accUp   = 0;
    this._accDown = 0;
    this._ticking = false;

    // bind
    this._onScroll = this._onScroll.bind( this );
    this._rafTick  = this._rafTick.bind( this );

    // inicio
    this._applyOnTop( this._lastY );
    window.addEventListener( 'scroll' , this._onScroll , { passive: true } );
  }

  _onScroll( ){
    if( this._ticking ) return;
    this._ticking = true;
    requestAnimationFrame( this._rafTick );
  }

  _rafTick( ){
    const y = Math.max( 0 , window.scrollY || window.pageYOffset || 0 );
    const dy = y - this._lastY;

    // Top class: activa cuando y <= offsetTop, desactiva cuando y > offsetTop
    this._applyOnTop( y );

    if( dy > 0 ){
      // desplazando hacia abajo
      this._accDown += dy;
      this._accUp = 0;
      if( y > this._config.offsetTop && this._accDown >= this._config.hideDelta ){
        this._element.classList.add( this._config.classHidden );
        this._accDown = 0; // resetea umbral
      }
    } else if( dy < 0 ){
      // desplazando hacia arriba
      this._accUp += ( -dy );
      this._accDown = 0;
      if( this._accUp >= this._config.showDelta ){
        this._element.classList.remove( this._config.classHidden );
        this._accUp = 0;
      }
    }

    this._lastY = y;
    this._ticking = false;
  }

  _applyOnTop( y ){
    if( y <= this._config.offsetTop ){
      this._element.classList.add( this._config.classOnTop );
    } else {
      this._element.classList.remove( this._config.classOnTop );
    }
  }

  destroy( ){
    window.removeEventListener( 'scroll' , this._onScroll );
  }

  /* ============
   * Init masiva
   * ===========*/
  static initAll( root = document ){
    const nodes = root.querySelectorAll( SELECTOR_DATA );
    const instances = [ ];
    nodes.forEach( el => {
      if( el._myhdInstance ) return;
      let cfg = { };
      const raw = el.getAttribute( SELECTOR );
      if( raw ){
        try { cfg = JSON.parse( raw ); } catch( _ ){ cfg = { }; }
      }
      el._myhdInstance = new MyHD( el , cfg );
      instances.push( el._myhdInstance );
    } );
    return instances;
  }
}

export default MyHD;
